import type { IUserProfile } from "@/core/@types/types";
import type { ILastTerm } from "./types";

const ROLES = {
  ADMINISTRADOR: "administrador.f360",
  SYS_ADMIN: "sysAdmin"
};

function parseRoles(roles: unknown): string[] {
  if (Array.isArray(roles)) {
    return roles.map(String).map((role) => role.trim());
  }

  if (typeof roles !== "string") {
    return [];
  }

  return roles.split(",").map((role) => role.trim());
}

export function isSysAdminRole(roles: unknown): boolean {
  return parseRoles(roles).includes(ROLES.SYS_ADMIN);
}

export function isClienteAdministradorRole(roles: unknown): boolean {
  return parseRoles(roles).includes(ROLES.ADMINISTRADOR);
}

export function isWebserviceEmail(email?: string | null): boolean {
  return Boolean(email?.toLowerCase().includes("webservice"));
}

export function canTermBeSignedByProfile(
  term: ILastTerm | null,
  userProfile: IUserProfile | null,
  roles: unknown
): boolean {
  if (!term || term.assinado) {
    return false;
  }

  if (
    !isClienteAdministradorRole(roles) ||
    isSysAdminRole(roles) ||
    isWebserviceEmail(userProfile?.Email)
  ) {
    return false;
  }

  const apiCanSign = term.podeAssinar ?? term.perfilPodeAssinar;

  return Boolean(apiCanSign);
}
